function Mission() {
  const points = [
    { title: 'Potential Before Geography', desc: 'Brilliance exists in Dallas Title I schools and Himalayan villages alike. Zip codes should never determine futures.' },
    { title: 'Resources, Not Charity', desc: 'We don\'t give handouts. We provide the exact tools students need to unlock their own potential.' },
    { title: 'One Bridge, Two Shores', desc: 'Connecting underserved students across continents, proving that educational equity is a global mission.' },
  ];

  return (
    <section className="mission" id="about">
      <div className="container">
        <div className="section-header centered">
          <h2 className="section-title">The Mission Is Simple</h2>
          <p className="section-subtitle">
            Get the right tools to students who have the determination but lack the resources.
            No matter where they are.
          </p>
        </div>
        <div className="mission-content">
          <div className="mission-text">
            <p className="mission-statement">
              <strong>We bridge the gap between potential and opportunity.</strong>{' '}
              In Dallas, that means backpacks and calculators for students who can't afford them.
              In rural Nepal, that means bringing the first science lab to villages where students
              have never performed an experiment. Same mission. Same determination. Different walls.
            </p>
            <div className="mission-points">
              {points.map((point, i) => (
                <div className="mission-point" key={i}>
                  <i className="fas fa-check-circle"></i>
                  <div>
                    <h4>{point.title}</h4>
                    <p>{point.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="mission-visual">
            <div className="bridge-visual">
              <div className="bridge-side dallas">
                <i className="fas fa-city"></i>
                <span>Dallas, Texas</span>
              </div>
              <div className="bridge-connector">
                <span className="bridge-icon" role="img" aria-label="bridge">&#127753;</span>
              </div>
              <div className="bridge-side nepal">
                <i className="fas fa-mountain"></i>
                <span>Dande, Nepal</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Mission;
